var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.$route.path,"unique-opened":true}},_vm._l((_vm.routersList),function(route,index){return _c('MenuItem',{key:index,attrs:{"item":route,"fatherPath":route.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }